<template>
  <layout-public>
    <page-meta />

    <hero />

    <highlight />

    <pricing />

    <one-off-plan-band dark :href="route('web-design') + '#one-off-plans'" />

    <strength />

    <feature />

    <portfolio :projects="projects" />

    <services />
  </layout-public>
</template>

<script>
import PageMeta from '@/Components/PageMeta.vue';
import LayoutPublic from '@/Layouts/Public.vue';

import Feature from '@/Pages/Index/Sections/Feature.vue';
import Hero from '@/Pages/Index/Sections/Hero.vue';
import Highlight from '@/Pages/Index/Sections/Highlight.vue';
import OneOffPlanBand from '@/Components/OneOffPlanBand.vue';
import Portfolio from '@/Pages/Index/Sections/Portfolio.vue';
import Pricing from '@/Pages/Index/Sections/Pricing.vue';
import Services from '@/Pages/Index/Sections/Services.vue';
import Strength from '@/Pages/Index/Sections/Strength.vue';

import { faArrowRight, faAward, faCheck, faClock, faCloudUploadAlt, faEnvelope, faFileAlt, faHdd, faHeartPulse, faLifeRing, faMapSigns, faPaperPlane, faPiggyBank, faQuoteRight, faServer, faSpinner, faStopwatch, faSync, faTimes } from '@fortawesome/free-solid-svg-icons';
import { library as FontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core';
import { scrollToId } from '@/smoothScroll';

FontAwesomeLibrary.add(faArrowRight, faAward, faCheck, faClock, faCloudUploadAlt, faEnvelope, faFileAlt, faHdd, faHeartPulse, faLifeRing, faMapSigns, faPaperPlane, faPiggyBank, faQuoteRight, faServer, faSpinner, faStopwatch, faSync, faTimes);

export default {
  components: {
    LayoutPublic,
    PageMeta,
    Feature,
    Hero,
    Highlight,
    OneOffPlanBand,
    Portfolio,
    Pricing,
    Services,
    Strength
  },

  props: {
    /* The featured projects, from `PortfolioCatalog::featured()`. The band
       shows a taste of the work and the listing at /portfolios shows all of it,
       so the band's projects are chosen in the catalog and handed in here rather
       than listed a second time in this page. */
    projects: {
      type: Array,
      default: () => []
    }
  },

  /* No `useI18n` here any more. The only two strings this page ever declared were
     its title and its description, and both were only read by `<meta>` in the
     document head. The head now comes from the shared `seo` prop, which the
     resolver builds on the server (see app/Support/Seo.php), so the dictionary had
     no reader left. The visible copy on this page belongs to the sections it
     composes, and each of those declares its own. */

  mounted() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) {
      return;
    }

    var id = hash.slice(1);
    this.$nextTick(() => {
      window.setTimeout(() => scrollToId(id), 80);
    });
  }
};
</script>
